module.exports = __webpack_public_path__ + "img/icon_coordinates8.131d84d6.png";